const DEV_ALERT = {
  ERROR_BOT_TOKEN: '5616829415:AAGI4ZF5vFGOGdmATKmGtP5OzDHfFe9ucqs',
  ERROR_CHAT_ID: '-1002735711138',
  INFO_BOT_TOKEN: '5616829415:AAGI4ZF5vFGOGdmATKmGtP5OzDHfFe9ucqs',
  INFO_CHAT_ID: '-1002735711138',
}

const CONSTANTS = {
  GOOGLE_MAP_API_KEY: 'AIzaSyAJKEbR8rBb0h4FZYo8GePSjbI9JmbWsmY',
}

export { DEV_ALERT, CONSTANTS }
